import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "timi-default-header-nav" }
const _hoisted_2 = { class: "timi-nav-actionbar" }
const _hoisted_3 = { class: "timi-main-nav-header" }
const _hoisted_4 = { class: "timi-logo" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "timi.tools", -1)
const _hoisted_7 = { class: "timi-main-nav-items" }
const _hoisted_8 = {
  key: 0,
  class: "timi-main-nav-item"
}
const _hoisted_9 = { class: "timi-main-nav-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      false
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 0,
            text: _ctx.$t('route.administration'),
            primary: true,
            onOnClick: _ctx.goToDashboard
          }, null, 8, ["text", "onOnClick"]))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 1,
            text: _ctx.$t('button.logout'),
            primary: true,
            onOnClick: _ctx.handleLogoutUser
          }, null, 8, ["text", "onOnClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_IconButton, {
        icon: _ctx.store.getters.svgIcons.burger,
        class: "",
        onOnClick: _ctx.handleToggleNavClick
      }, null, 8, ["icon", "onOnClick"])
    ]),
    _createElementVNode("nav", {
      class: _normalizeClass(["timi-main-nav", { 'active': _ctx.navActive }]),
      role: "navigation"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("i", {
            class: "svgicon timi-icon",
            innerHTML: _ctx.store.getters.svgIcons.timi
          }, null, 8, _hoisted_5),
          _hoisted_6
        ]),
        _createVNode(_component_IconButton, {
          icon: _ctx.store.getters.svgIcons.close,
          class: "close-main-nav",
          onOnClick: _ctx.handleToggleNavClick
        }, null, 8, ["icon", "onOnClick"])
      ]),
      _createElementVNode("ul", _hoisted_7, [
        (_ctx.checkAdmin())
          ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
              _createVNode(_component_router_link, {
                class: _normalizeClass({'is--active': _ctx.checkIsActive(['Dashboard'])}),
                to: "/administration/dashboard"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("route.administration")), 1)
                ]),
                _: 1
              }, 8, ["class"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("li", _hoisted_9, [
          _createVNode(_component_Button, {
            text: _ctx.$t('button.logout'),
            secondary: true,
            onOnClick: _ctx.handleLogoutUser
          }, null, 8, ["text", "onOnClick"])
        ])
      ])
    ], 2),
    _renderSlot(_ctx.$slots, "default")
  ]))
}